export const getLocalizedText = (textObj, language = 'es') => {
  if (!textObj) return '';
  if (typeof textObj === 'string') return textObj;
  return textObj[language] || textObj.es || textObj.en || '';
};

export const formatPrice = (price, currency = 'EUR') => {
  if (!price) return 'Consultar';
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: currency,
  }).format(price);
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('es-ES', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

export const formatDuration = (minutes) => {
  if (!minutes) return '';
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins > 0 ? `${hours}h ${mins}min` : `${hours}h`;
};
